<template>
    <div id="login-page" class="d-flex align-items-center h-100">
        <landing-page></landing-page>
        <section class="login-section right order-first order-md-last">
            <div class="login-form">
                <h2 class="form-title">{{ __("signInTitle", this.translations.loginPage) }}</h2>
<!--                <p class="form-description">Use your username and password to login.-->
<!--                    <router-link to="/sign-up">Click here</router-link>-->
<!--                    if you don't have an account.-->
<!--                </p>-->
                <div class="form-error mb-3" v-if="hasErrors">
                    <i class="fas fa-info-circle"></i>You have the following errors:
                    <ul>
                        <li v-for="(error, index) in errors" :key="index">{{ error }}</li>
                    </ul>
                </div>
                <qw-input class="form-field mb-2"
                          name="username"
                          type="text"
                          icon="fas fa-envelope"
                          placeholder="Username"
                          autocomplete="off"
                          v-model="form.username"/>
                <qw-input class="form-field mb-3"
                          name="password"
                          icon="fas fa-unlock"
                          placeholder="Password"
                          autocomplete="off"
                          :endIcon="show ? 'fas fa-eye' : 'fas fa-eye-slash'"
                          @buttonClick="show = !show"
                          :type="show ? 'text' : 'password'"
                          v-model="form.password"/>
                <button class="form-button" @click="login()" v-if="status === 'ready'" :disabled="hasMissingFields">{{
                    __('loginButton', this.translations.loginPage) }}
                </button>
                <button class="form-button" disabled v-if="status === 'loading'"><i
                        class="fas fa-circle-notch fa-spin"></i>{{ __('loading', this.translations.global) }}
                </button>
                <router-link :to="'forgot-password'" style="color: white!important;font-size: 14px">Forgot Password?</router-link>
            </div>
        </section>
    </div>
</template>

<script>
    import QwInput from "@/components/global/form/QWInput";
    import Auth from "@/services/AuthService";
    //import Redirectr from "@/utils/Redirectr";
    import Validator from "@/utils/Validator";
    import Session from "@/utils/Session";
    import MPWorkplace from "@/utils/MPWorkplace";
    import LandingPage from "../components/LandingPage";

    export default {
        name: "login-page",
        components: {
            LandingPage,
            QwInput
        },
        data() {
            return {
                status: "ready",
                show: false,
                errors: [],
                form: {
                    username: "",
                    password: "",
                },
                validationRules: {
                    username: "required",
                    password: "required"
                }
            };
        },
        mounted() {
            localStorage.clear();
            window.axios = MPWorkplace.newAxios();
            this.bindEnterKey();
        },
        destroyed() {
            this.unbindEnterKey();
        },
        methods: {
            bindEnterKey() {
                /**
                 * Used JavaScript instead of the VueJS event @keydown.enter="login()"
                 * since using VueJS events should be handled on the element
                 * in focus or multiple times on different elements...
                 */
                document.onkeydown = (e) => {
                    let keyCode = e.keyCode === undefined ? e.key : e.keyCode;
                    switch (keyCode) {
                        case 13:
                            this.login();
                            break;
                    }
                }
            },
            unbindEnterKey() {
                document.onkeydown = null;
            },
            login() {
                this.errors = [];
                let validator = new Validator();
                validator.validate(this.form, this.validationRules);
                if (validator.hasErrors()) {
                    this.errors = validator.list();
                    return;
                }

                this.submitLogin();
            },
            async submitLogin() {
                this.status = "loading";
                try {
                    Auth.login(this.form.username, this.form.password)
                        .then(loginResponse => {
                          Session.set(loginResponse.data.Login);
                          window.axios = MPWorkplace.newAxios();
                          this.redirect();
                        })
                        .catch(() => {
                          this.$store.commit("setToastMessage", {
                            title: 'Wrong Username and/or Password',
                            type: 'error', hideIcon: false
                          });
                        });
                } catch (e) {
                    this.handleFailedLogin(e);
                } finally {
                    this.status = "ready";
                }
            },
            redirect() {
              /*
                let redirect = new Redirectr(this.$route);
                location.href = redirect.hasRedirect()
                    ? `/redirect?redirectTo=${redirect.redirectTo}`
                    : "/";
              */

              location.href = 'https://drr.solutions/lrc-crisis';
            },
            handleFailedLogin(response) {
                var error = response && (response.status === 403 || response.status === 401)
                    ? "Incorrect username or password."
                    : "An error occurred. Please contact administrator.";

                this.errors.push(error);
            },
            setLanguage(language) {
                this.$store.dispatch("setLanguage", language);
            },
            isCurrentLanguage(language) {
                return this.$store.getters.appLanguage === language;
            }
        },
        computed: {
            hasMissingFields() {
                return !(this.form.username && this.form.password)
            },
            hasErrors() {
                return !!(this.errors && this.errors.length);
            }
        }
    }
</script>

<style lang="scss" scoped>
    #login-page {
        overflow: auto;

        .login-section {
            display: flex;
            align-items: center;
            flex-direction: row;
            height: 100%;

            .centered {
                display: flex !important;
                justify-content: center !important;
            }

            .bottom-section {
                justify-content: center;
                position: absolute;
                width: 100%;
                bottom: 10px;
            }

            &.left {
                position: relative;

                .main-title {
                    font-family: $raleway;
                    color: $darkest-gray;
                    font-weight: 900;
                    line-height: 1.1;
                    text-transform: uppercase;
                    font-size: 40px;

                    .line {
                        display: flex;
                        align-items: center;
                    }
                }
            }

            &.right {
                position: relative;
                background-color: #ab0d17;

                .login-form {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    flex-direction: column;
                    width: 100%;

                    .form-title {
                        width: 100%;
                        margin: 0 0 10px 0;
                        font-size: 22px;
                        font-weight: 700;
                        font-family: $raleway;
                        color: $white;
                        line-height: 1;
                        text-align: left;
                    }

                    .form-description {
                        font-family: $roboto;
                        font-size: 14px;
                        line-height: 1.4;
                        color: $light-gray;
                        text-align: left;

                        a {
                            color: $light-gray !important;
                            text-decoration: underline;
                            cursor: pointer;

                            &:hover {
                                text-decoration: none;
                            }
                        }
                    }

                    .form-error {
                        width: 100%;
                        color: $white;
                        font-family: $lato;
                        font-weight: 400;
                        font-size: 15px;
                        color: $orange;

                        ul {
                            margin: 0;
                        }

                        i {
                            margin: 0px 7px 0px 0px;
                        }
                    }

                    .form-field {
                        width: 100%;
                    }

                    .form-button {
                        display: block;
                        width: 100%;
                        padding: 7px 0;
                        font-weight: 700;
                        font-family: $raleway;
                        border: 2px solid $white !important;
                        border-radius: 25px;
                        color: $primary;
                        background-color: $white;

                        i {
                            margin: 0 10px 0 0;
                        }

                        &:hover {
                            color: $white;
                            background-color: transparent;
                        }

                        &:disabled {
                            border: 2px solid $light-gray !important;
                            background-color: $light-gray;
                            color: $dark-gray;

                            &:hover {
                                background-color: $light-gray;
                            }
                        }
                    }
                }

                .languages {
                    display: flex;
                    align-items: center;

                    .language-btn {
                        margin: 0 5px 0 0;
                        padding: 1px 8px;
                        font-size: 12px;
                        font-weight: 700;
                        font-family: $raleway;
                        text-transform: uppercase;
                        color: $white;
                        background: none;
                        @include removeBootstrapOutline;
                        border: 2px solid transparent !important;
                        border-radius: 3px;
                        cursor: pointer;
                        @include fastestTransition;

                        &:hover, &.active {
                            border: 2px solid $white !important
                        }

                        &:last-child {
                            margin: 0;
                        }
                    }
                }
            }
            .footer {
              position: absolute;
              bottom: 0px;
              width: 100% !important;
              height: 4% !important;

              a {
                text-decoration: none;

                &:hover {
                  font-weight: bolder;
                }
              }

              p {
                font-weight: bold;
                font-size: 30px;
                text-align: center;
                color: white;

                &:hover {
                  font-weight: bolder;
                }
              }

              img {
                width: 100% !important;
                height: 100% !important;
              }
            }
        }
    }

    .dark {
        #login-page {
            .login-section {
                &.left {
                    .main-title {
                        color: $white;
                    }
                }

                &.right {
                    background-color: $extra-darker-gray;

                    .login-form {
                        .form-error {
                            color: $light-red;
                        }

                        .form-button {
                            color: $extra-darker-gray;

                            &:hover {
                                color: $white;
                            }

                            &:disabled {
                                color: $gray;
                                border: 2px solid $extra-dark-gray !important;
                                background-color: $extra-dark-gray;
                            }
                        }
                    }
                }
            }
        }
    }

    @media screen and (max-width: $breakpoint-md) {
        #login-page {
            flex-direction: column;

            .login-section {
                height: auto;
                flex-direction: column;

                .centered {
                    display: block;
                }

                .bottom-section {
                    position: static;
                    transform: translate(0);
                    padding: 10px 0;
                }

                &.left {
                    width: 100%;

                    .main-title {
                        font-size: 22px;

                        .line {
                            display: inline;
                        }
                    }
                }

                &.right {
                    width: 100%;

                    .login-form {
                        padding: 30px 20px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-md) {
        #login-page {
            .login-section {
                .centered {
                    display: block;
                }

                &.left {
                    width: 50%;

                    .main-title {
                        font-size: 30px;
                    }
                }

                &.right {
                    width: 50%;

                    .login-form {
                        padding: 0 25px;
                    }
                }
            }
        }
    }

    @media screen and (min-width: $breakpoint-lg) {
        #login-page {
            .login-section {
                &.left {
                    width: 70%;
                }

                &.right {
                    width: 30%;

                    .login-form {
                        padding: 0 35px;
                    }
                }
            }
        }
    }
</style>
